import { GraphBuilder } from '../graph/builder';
import { ComponentDef } from './types';

export const decodingStrategiesComponent: ComponentDef = {
  id: 'decoding-strategies',
  name: 'Decoding Strategies',
  description: 'Greedy, beam search, temperature scaling, top-k, and top-p sampling from logits.',
  category: 'function',
  params: [
    { name: 'seq_len', label: 'Sequence length', type: 'number', default: 128, min: 1, max: 8192, step: 1 },
    { name: 'vocab_size', label: 'Vocab size', type: 'number', default: 32000, min: 1000, max: 200000, step: 1000 },
    { name: 'temperature', label: 'Temperature', type: 'number', default: 0.8, min: 0.1, max: 2, step: 0.1 },
    { name: 'top_k', label: 'Top-K', type: 'number', default: 50, min: 1, max: 1000, step: 1 },
    { name: 'top_p', label: 'Top-P', type: 'number', default: 0.9, min: 0.1, max: 1, step: 0.05 },
    { name: 'beam_width', label: 'Beam width', type: 'number', default: 3, min: 2, max: 10, step: 1 },
    { name: 'variant', label: 'Variant', type: 'select', default: 'all', options: [{ label: 'All (comparison)', value: 'all' }, { label: 'Greedy', value: 'greedy' }, { label: 'Top-K', value: 'topk' }, { label: 'Top-P (Nucleus)', value: 'topp' }, { label: 'Beam Search', value: 'beam' }] }
  ],
  buildGraph: (params) => {
    const seq_len = Number(params.seq_len);
    const vocab_size = Number(params.vocab_size);
    const variant = params.variant;

    const g = new GraphBuilder();
    g.input('logits', [seq_len, vocab_size]);
    g.softmax('probs', 'logits', -1);

    if (variant === 'all') {
      g.scale('greedy', 'probs', 'Argmax');
      g.router('topk', 'probs', [seq_len, Number(params.top_k)]);
      g.scale('topp', 'probs', 'Top-p');
      g.scale('beam', 'probs', 'Beam Search');
      g.concat('out_cat', ['greedy', 'topk', 'topp', 'beam'], [seq_len, vocab_size * 4]);
      g.output('out', 'out_cat');
    } else if (variant === 'greedy') {
      g.scale('token', 'probs', 'Argmax');
      g.output('out', 'token');
    } else if (variant === 'topk') {
      g.router('topk', 'probs', [seq_len, Number(params.top_k)]);
      g.scale('token', 'topk', 'sample');
      g.output('out', 'token');
    } else if (variant === 'topp') {
      g.scale('cumsum', 'probs', 'cumsum');
      g.mask('nucleus', 'cumsum', [seq_len, vocab_size]);
      g.scale('token', 'nucleus', 'sample');
      g.output('out', 'token');
    } else {
      g.scale('beams', 'probs', 'top-b beams');
      g.scale('token', 'beams', 'select best');
      g.output('out', 'token');
    }

    return g.build();
  }
};
